<template lang="pug">
  .component-parking-lot
    .card
      .inner-content
        .component-card-3
          .row
            .column.shrink
              dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
                ParkingLotActionButtons(:parkingLot="item")
            .column
              .field-parking-lot-id PL{{item.id}}
              .field-parking-lot-name {{item.name}}
            .column
              .label Assigned slots
              .value {{item.slots}}
            .column
              .label Actual slots
              .value {{item.parking_slots_count}}
            .column
              .label Occupied slots
              .value {{item.vehicle_slots_count}}
            .column
              .label Disabled slots
              .value {{item.vehicle_slots_disabled}}
            .column.shrink
              router-link(:to="{name:'parkingLot', params:{id:item.id}}")
                i.fa.fa-angle-right.fa-3x.action
</template>

<script>
  import Card3 from '../structure/Card3'
  import Dropdown from '../structure/foundation/Dropdown'
  import ParkingLotActionButtons from '../structure/ui/actions/ParkingLotActionButtons'

  export default {
    name: 'ParkingLot',
    components: {ParkingLotActionButtons, Dropdown, Card3},
    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ParkingLot.vue?2577f01a